export const DEFAULT_DXF_LABEL_COLOR = "#F283E5";
export const DEFAULT_DXF_TEXT_SPHERE_COLOR = "#FF0000";
//# sourceMappingURL=defaults.js.map